import { useState, useEffect } from "react";
import Logger from "../logger";
import { LoginStatus } from "../constants/loginStatus";
import { Auth0TokenError } from "../errors";
import { baseContainer } from "../index";
import { useAuth0 } from "@auth0/auth0-react";

//this exposes internal set state of useLogin hook so it can be used in authentication service
let changeStatus = () => { };

const useLogin = () => {
  const [authorizationStatus, setAuthorizationStatus] = useState(
    LoginStatus.Pending
  );
  const {
    isAuthenticated,
    isLoading,

  } = useAuth0();

  Logger.of("App.hooks.useLogin").info({ isAuthenticated, isLoading, authorizationStatus });

  // initialization of exposed changeStatus wrapper
  changeStatus = (status) => {
    setAuthorizationStatus(status);
  };

  //Auth flow logic
  const startAuthorizationFlow = async () => {
    try {
      //STEP 1 :
      //Get first token from identity
      Logger.of("App.hooks.useLogin.startAuthorizationFlow").info("Getting token from identity");
      await baseContainer.authenticationService.getAuthToken();

      //STEP 2 :
      //Check from authentication service to see if user meets the bussiness requirements to go to home page.
      //(env variable force tenant is false or user has a tenant in his token claims)
      if (baseContainer.authenticationService.canViewApp()) {
        Logger.of("App.hooks.useLogin.startAuthorizationFlow.canViewApp").info("Can view app");
        setAuthorizationStatus(LoginStatus.Authorized);
      } else {
        Logger.of("App.hooks.useLogin.startAuthorizationFlow.canViewApp").info("Get tenants");
        //get user tenants from authentication service (api call)
        let tenants = await baseContainer.authenticationService.getTenants();
        if (tenants.length === 0) {
          //if user isnt assigned to any tenant then show the error screen.
          // setAuthorizationStatus(LoginStatus.NoAssignedTenants);
          setAuthorizationStatus(LoginStatus.UnAuthorized);
        } else if (tenants.length === 1) {
          //extend token automatically if user has 1 tenant
          await baseContainer.authenticationService.extendLogInWithTenant(
            tenants[0].id
          );
          setAuthorizationStatus(LoginStatus.Authorized);
        } else {
          //user is assigned to multiple tenants so he goes to tenant selection screen.
          setAuthorizationStatus(LoginStatus.TenantSelection);
        }
      }
    } catch (err) {
      if (err instanceof Auth0TokenError) {
        baseContainer.authenticationService.postLogout(false);
      } else {
        Logger.of("App.hooks.useLogin").error(err);
        //to do set screens based on api error response
        setAuthorizationStatus(LoginStatus.UnAuthorized);
      }
    }
  };

  useEffect(() => {
    Logger.of("App.hooks.useLogin").info("useLogin hook effect", { isAuthenticated, isLoading, authorizationStatus });
    if (isAuthenticated) {
      //show loader and begin authorization flow process
      setAuthorizationStatus(LoginStatus.Pending);
      startAuthorizationFlow();
    } else {
      setAuthorizationStatus(LoginStatus.UnAuthenticated);
    }
  }, [isAuthenticated, isLoading]);

  return {
    loginStatus: authorizationStatus,
  };
};

export default useLogin;

export { changeStatus };
